import { getOr } from 'lodash/fp';
import React from 'react';
import PropTypes from 'prop-types';
import { compose, withPropsOnChange } from 'recompose';
import { LOCATIONS_ALL_ID } from '../../../containers/BrandBarber/constants';
import BrandServicesForm from '../../brandServicesForm/brandServicesForm';
import withCanModifyBarber from './withCanModifyBarber';
import { sortBrandBarberServices } from '../helpers/servicesOrder';

const BrandServices = ({ canModify, services, shopNamesById }) => (
  <div className="u-mv u-height-510 u-scrollable">
    <fieldset disabled={!canModify}>
      <BrandServicesForm services={services} shopNamesById={shopNamesById} />
    </fieldset>
  </div>
);

BrandServices.propTypes = {
  canModify: PropTypes.bool.isRequired,
  services: PropTypes.array.isRequired,
  shopNamesById: PropTypes.object.isRequired,
};

const enhance = compose(
  withCanModifyBarber,
  withPropsOnChange(['barberLocationData', 'services'], (props) => {
    const newServices = props.barberLocationData[LOCATIONS_ALL_ID]
      ? Object.values(getOr([], `${LOCATIONS_ALL_ID}.services`)(props.barberLocationData))
      : Object.values(getOr([], 'services', Object.values(props.barberLocationData)[0])).map(service => ({
        ...service,
        shopIds: [LOCATIONS_ALL_ID, service.locationId],
        shopId: service.locationId,
        singleShopService: true,
      }));

    return {
      services: sortBrandBarberServices(newServices, props.shopNamesById),
    };
  }),
);

export default enhance(BrandServices);
